import { TabsKRMODAL } from "../keyResults/interface";

export interface IConsulted {
    efa005Id?: number;
    efa004Id?: number;
    notifyParticipant?: "S" | "N";
}

export interface IInformed {
    efa005Id?: number;
    efa004Id?: number;
    notifyParticipant?: "S" | "N";
}

export interface IOrgChartProps {
    openModalAddOrChangeKr?: (id?: number, okrParentId?: number, okrParentTitle?: string, onCallback?: Function, tabInitSelected?: TabsKRMODAL) => void;
    openModalDeleteKr?: (id: number, title: string, onCallback?: Function) => void;
    openModalPerformCheckIn?: (krId: number,  krTitle: string, measurementType: string, measurementForm: string, realizedValue: string | number, percent: string | number, colorGraph: string, initialValue?: string | number, goal?: string | number, onCallback?: Function) => void;
    openModalOKRComments?: (id: number, titleOkr: string, onCallback?: Function, disabled?: boolean) => void;
    openModalOKRAttachments?: (id: number, titleOkr: string, onCallback?: Function, disabled?: boolean) => void;
}

export interface IObjective{
    attachmentsNumber: number;
    commentsNumber: number;
    createdByImage: string;
    createdByName: string;
    dateCreated: Date;
    dateModified: Date;
    modifiedByImage: string;
    modifiedByName: string;
    oka001Codigo: string;
    oka001Codigoint: number;
    oka001Dtfim: Date;
    oka001Dtinicio: Date;
    oka001Efa002Id: number;
    oka001Efa005Id: number;
    oka001Efa005Id2: number;
    oka001Id: number;
    oka001Missao: string;
    oka001Nivel: number;
    oka001Notificaautoridade: "S" | "N";
    oka001Notificaresponsavel: "S" | "N";
    oka001Oka001Id: number | null;
    oka001Periodo: ""
    oka001Peso: number;
    oka001Premissas: string;
    oka001Taa001Id: number;
    oka001Taa006Id: number | null;
    oka001Tags: string | string[] | null;
    oka001Titulo: string;
    oktba002: {
        oka002Cor: string;
        oka002Id: number;
        oka002Oka001Id: number;
        oka002Valorfim: number;
        oka002Valorini: number;
    }[];
    oktba006: {
        oka006Efa004Id: number | null;
        oka006Efa004Nome: string;
        oka006Efa005Id: number | null;
        oka006Efa005Nome: string;
        oka006Id: number;
        oka006Notificaparticipante: "N" | "S";
        oka006Oka001Id: number;
        oka006Tipo: "I" | "C";
    }[];
    oktbb001001: {
        checkInFrequency: string;
        colorGraph: string | null;
        okb001Descricao: string;
        okb001Efa005Id: number;
        okb001Efa005Imagem: string;
        okb001Efa005Nome: string;
        okb001Formamedicao: number;
        okb001Id: number;
        okb001Meta: number;
        okb001Oka001Id: number;
        okb001Peso: number;
        okb001Situacao: number;
        okb001Tipomedicao: number;
        okb001Titulo: string;
        okb001Valorinicial: number;
        percent: number;
        realizedValuesCheckIn: number;
    }[];
}

export enum TabsOKRMODAL {
	GENERAL = 0,
	RACI = 1,
	METRICS = 2,
	KEY_RESULTS = 3
}

interface IOrgChartObjectivesRef{
    openModalDelete: (id: number, title: string, onCallback?: Function) => void;
    openModalAddOrChange: (id?: number, okrParentId?: number, onCallback?: Function, tabInitSelected?: TabsOKRMODAL | undefined) => void;
}

export default IOrgChartObjectivesRef;
